import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { PathBuilder, RequestTypes, axiosBaseQuery } from "../../utils";
import {
  IMessageResponse,
  credential,
  IMedicalCardTemplate,
  IMedicalCardTemplateDto,
  MedicalCardTemplateTypes,
} from "../../shared";

export const MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY = "medicalCardTemplatesApi";

export const medicalCardTemplatesApi = createApi({
  reducerPath: MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY,
  baseQuery: axiosBaseQuery({
    baseUrl: credential.apiUrl as string,
  }),
  tagTypes: [MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY],
  endpoints: (build) => ({
    createMedicalCardTemplate: build.mutation<
      IMedicalCardTemplate,
      IMedicalCardTemplateDto
    >({
      query: (params) => ({
        url: PathBuilder.medicalCardTemplatesApi.createMedicalCardTemplate(),
        method: RequestTypes.post,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      }),
      invalidatesTags: [MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY],
    }),
    updateMedicalCardTemplate: build.mutation<
      IMedicalCardTemplate,
      { params: IMedicalCardTemplateDto; id: string }
    >({
      query: (data) => {
        const { params, id } = data;

        return {
          url: PathBuilder.medicalCardTemplatesApi.updateMedicalCardTemplate(
            id,
          ),
          method: RequestTypes.put,
          headers: {
            "Content-Type": "application/json",
          },
          data: params,
        };
      },
      invalidatesTags: [MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY],
    }),
    fetchMedicalCardTemplateList: build.query<
      IMedicalCardTemplate[],
      {
        type: MedicalCardTemplateTypes;
      }
    >({
      query: (params) => ({
        url: PathBuilder.medicalCardTemplatesApi.fetchMedicalCardTemplateList(),
        method: RequestTypes.get,
        params: {
          type: params.type,
        },
      }),
      providesTags: () => [MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY],
    }),
    fetchMedicalCardTemplate: build.query<IMedicalCardTemplate, string>({
      query: (medicalCardTemplateId) => ({
        url: PathBuilder.medicalCardTemplatesApi.fetchMedicalCardTemplate(
          medicalCardTemplateId,
        ),
        method: RequestTypes.get,
      }),
      providesTags: () => [MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY],
    }),
    deleteMedicalCardTemplate: build.mutation<IMessageResponse, string>({
      query: (medicalCardTemplateId) => ({
        url: PathBuilder.medicalCardTemplatesApi.deleteMedicalCardTemplate(
          medicalCardTemplateId,
        ),
        method: RequestTypes.delete,
      }),
      invalidatesTags: [MEDICAL_CARD_TEMPLATES_API_REDUCER_KEY],
    }),
  }),
});
